import { configureStore } from "@reduxjs/toolkit"
import cartSlice from "../features/cart/cartSlice"
import orderSlice from "../features/orders/orderSlice"
import uiSlice from "../features/ui/uiSlice"
import menuSlice from "../features/menu/menuSlice"
import languageSlice from "../features/language/languageSlice"
import authSlice from "../features/auth/authSlice"
import splashSlice from "../features/ui/splashSlice"
import bannersSlice from "../features/ui/bannersSlice"
import createPaymentSlice from "../features/payment/createPaymentSlice"
import createOrderSlice from "../features/orders/createOrderSlice"
import paymentSlice from "../features/payment/paymentSlice"
import offersReducer from "../features/offers/offersSlice"
import { offersListenerMiddleware } from "../features/offers/offersListeners"

export const store = configureStore({
  reducer: {
    cart: cartSlice,
    order: orderSlice,
    ui: uiSlice,
    menu: menuSlice,
    language: languageSlice,
    auth: authSlice,
    splash: splashSlice,
    banners: bannersSlice,
    createPayment: createPaymentSlice,
    createOrder: createOrderSlice,
    payment: paymentSlice,
    offers: offersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(offersListenerMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
